import React from "react";
import Reveal, { Eyebrow } from "../common/Reveal";
import { journey, BOOK_URL } from "../../mock";

export default function Journey() {
  return (
    <section className="bg-white py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="text-center">
          <Reveal><Eyebrow color="green">{journey.eyebrow}</Eyebrow></Reveal>
          <Reveal delay={80}><h2 className="mt-4 font-serif text-4xl lg:text-5xl text-lybl-ink">{journey.title}</h2></Reveal>
        </div>

        <div className="mt-16 space-y-16 lg:space-y-24">
          {journey.steps.map((s, i) => (
            <Reveal key={s.n}>
              <div className={`grid items-center gap-8 lg:gap-16 lg:grid-cols-2 ${i % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""}`}>
                <div className="relative">
                  <div className="overflow-hidden rounded-3xl">
                    <img src={s.image} alt={s.title} className="w-full h-72 lg:h-96 object-cover" />
                  </div>
                  <div className="absolute -bottom-5 left-5 right-5 lg:left-8 lg:right-auto lg:max-w-xs rounded-2xl bg-white shadow-xl ring-1 ring-black/5 px-5 py-4">
                    <p className="text-[13px] text-lybl-ink/80 leading-snug">{s.note}</p>
                  </div>
                </div>
                <div>
                  <div className="h-12 w-12 rounded-full bg-lybl-green text-white font-serif text-xl flex items-center justify-center">{s.n}</div>
                  <h3 className="mt-5 font-serif text-3xl text-lybl-ink">{s.title}</h3>
                  <p className="mt-3 text-lybl-green font-medium">{s.lead}</p>
                  <p className="mt-3 text-lybl-muted text-[15px] leading-relaxed max-w-md">{s.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-16 text-center">
          <a href={BOOK_URL} target="_blank" rel="noreferrer" data-evt="schedule" className="inline-flex items-center gap-2 rounded-full bg-lybl-green px-7 py-4 text-[15px] font-medium text-white hover:bg-lybl-greenDark transition-colors">
            {journey.cta} <span aria-hidden>→</span>
          </a>
        </div>
      </div>
    </section>
  );
}
